/* eslint-disable react/prop-types, react/jsx-props-no-spreading */

import React, { useMemo } from "react";
import TextInput from "../../../../shared/v2/TextInput";

const SearchFilter = ({ value }) => {
  return <TextInput name="search" placeholder="search" value={value} type="hidden" />;
};

export default SearchFilter;
